import Request from '../Request.utils'
export interface ITriggerFetchDataRequestBody {
  forCustomers?: boolean;
  forFullOrders?: boolean;
  forItems?: boolean;
  forLedger?: boolean;
  forLineExt?: boolean;
  fullOrderCompanyId?: string;
  fullOrderLocationId?: string;
  ledgerSelect?: string[];
  lineExtSelect?: string[];
  lineOnly?: boolean;
  lineSelect?: string[];
  postingDateFrom: string;
  postingDateTo: string;
  targetDateField?: 'postingDate' | 'SystemModifiedAt';
  upsert?: boolean;
}
export interface IGenSIRReportRequestBody {
  client: string;
  filterLocations?: string[];
  format?: 'excel' | 'pdf';
  postingDateFrom: string;
  postingDateTo: string;
}
export interface IGenSIRReportStatusRequestQuery {
  jobId: string;
}
export interface IGenSiteReportRequestBody {
  budgetCategory?: 'Consumables' | 'Consumable' | 'Materials' | 'Material';
  client?: string;
  filterLocations?: string[];
  format?: 'excel' | 'pdf' | 'json';
  postingDateFrom: string;
  postingDateTo: string;
}
export interface IGenSiteReportStatusRequestQuery {
  jobId: string;
}
export interface IStatsRequestBody {
  client?: string;
  filterLocations?: string[];
  postingDateFrom: string;
  postingDateTo: string;
}
export interface IGetStatsInvoicesRequestBody {
  client?: string;
  countBy?: string[];
  countUniqueBy?: string;
  filterLocations?: string[];
  filterProductType?: string;
  postingDateFrom: string;
  postingDateTo: string;
  summaryBy?: string;
  topGroupBy?: string;
  topGroupBySumValue?: string[];
}
export interface IGenMonthlySpentRequestBody {
  client: string;
  filterLocations?: string[];
  format?: 'excel' | 'json';
  year: number;
}
export interface IGenProductsBreakdownRequestBody {
  client: string;
  filterLocations?: string[];
  format?: 'excel' | 'json';
  postingDateFrom: string;
  postingDateTo: string;
}
export interface IGenClientReportRequestBody {
  client: string;
  filterLocations?: string[];
  format?: 'excel' | 'pdf';
  postingDateFrom: string;
  postingDateTo: string;
  reportType?: 'Consumable' | 'Consumables' | 'Material' | 'Materials' | 'All';
}
export interface IGenClientReportStatusRequestQuery {
  jobId: string;
}
export interface IInvoiceLedgersRequestBody {
  filterLocations?: string[];
  postingDateFrom: string;
  postingDateTo: string;
}
export interface ILocationInfoRequestBody {
  filterLocations?: string[];
}
export interface ILastSyncTimeRequestBody {
  client: string;
  filterLocations?: string[];
}
export interface IGenProductCategoriesBreakdownRequestBody {
  categoryType: 'product' | 'contract';
  client: string;
  filterLocations?: string[];
  format?: 'excel' | 'json';
  postingDateFrom: string;
  postingDateTo: string;
}
export interface IGenDeliveryEmissionsRequestBody {
  client: string;
  filterLocations?: string[];
  format?: 'json';
  postingDateFrom: string;
  postingDateTo: string;
}
export interface IGenCarbonFootprintRequestBody {
  client: string;
  filterLocations?: string[];
  format?: 'json';
  postingDateFrom: string;
  postingDateTo: string;
}
export interface IInvoiceDetailRequestParams {
  no: string;
}
export interface IInvoiceDetailPostRequestBody {
  no: string;
}
export interface IGetStatsLedgerInvoicesRequestBody {
  countBy?: string[];
  countUniqueBy?: string;
  filterLocations?: string[];
  filterProductType?: string;
  postingDateFrom: string;
  postingDateTo: string;
  summaryBy?: string;
  topGroupBy?: string;
  topGroupBySumValue?: string[];
}
export interface IListBCOrderRequestQuery {
  details?: boolean;
  endDate?: string;
  hasDeliveryStatus?: 'false' | 'true' | '1' | '0';
  isBackOrder?: boolean;
  isShopifyOrder?: '' | '1' | '0';
  limit?: number;
  locationExternalId?: string;
  offset?: number;
  orderBy?: 'createdAt' | 'updatedAt';
  search?: string;
  startDate?: string;
  status?: string;
}
export interface IAppInvoiceLedgersRequestBody {
  filterLocations?: string[];
  postingDateFrom: string;
  postingDateTo: string;
}
export interface IAppLocationInfoRequestBody {
  filterLocations?: string[];
}
export interface IAppInvoiceDetailPostRequestBody {
  no: string;
}
export interface IListDespatchNotesRequestQuery {
  limit?: number;
  offset?: number;
  search?: string;
  status?: 'all' | 'unshipped' | 'shipped' | 'APC' | 'FedEx';
}
export interface IGetDespatchNoteRequestParams {
  despatchNoteNo: string;
}
export interface IGenerateDespatchNoteLabelsRequestBody {
  apcProductCode?: 'ND16' | 'ND10' | 'WD10' | 'WD12';
  contactPhone?: string;
  fedexServiceType?: 'FEDEX_PRIORITY' | 'FEDEX_FIRST' | 'FEDEX_PRIORITY_EXPRESS' | 'FEDEX_ECONOMY_SELECT' | 'FEDEX_PRIORITY_EXPRESS_SATURDAY';
  overallWeightKg?: number;
  packageCount?: number;
  packages?: {
    heightCm?: number;
    lengthCm?: number;
    weightKg: number;
    widthCm?: number;
  }[];
}
export interface IGenerateDespatchNoteLabelsRequestParams {
  despatchNoteNo: string;
}


class BcAPI {
  triggerFetchData = async (body: ITriggerFetchDataRequestBody) => {
    const res = await Request.call('/api/bc/trigger-fetch-data', 'POST', undefined, undefined, body, );
    return res;
  }
  genSIRReport = async (body: IGenSIRReportRequestBody) => {
    const res = await Request.call('/api/bc/gen-sir-report', 'POST', undefined, undefined, body, );
    return res;
  }
  genSIRReportStatus = async (query: IGenSIRReportStatusRequestQuery) => {
    const res = await Request.call('/api/bc/gen-sir-report-status', 'GET', undefined, query, undefined, );
    return res;
  }
  genSiteReport = async (body: IGenSiteReportRequestBody) => {
    const res = await Request.call('/api/bc/gen-site-report', 'POST', undefined, undefined, body, );
    return res;
  }
  genSiteReportStatus = async (query: IGenSiteReportStatusRequestQuery) => {
    const res = await Request.call('/api/bc/gen-site-report-status', 'GET', undefined, query, undefined, );
    return res;
  }
  stats = async (body: IStatsRequestBody) => {
    const res = await Request.call('/api/bc/stats', 'POST', undefined, undefined, body, );
    return res;
  }
  getStatsInvoices = async (body: IGetStatsInvoicesRequestBody) => {
    const res = await Request.call('/api/bc/get-stats-invoices', 'POST', undefined, undefined, body, );
    return res;
  }
  genMonthlySpent = async (body: IGenMonthlySpentRequestBody) => {
    const res = await Request.call('/api/bc/gen-monthly-spent', 'POST', undefined, undefined, body, );
    return res;
  }
  genProductsBreakdown = async (body: IGenProductsBreakdownRequestBody) => {
    const res = await Request.call('/api/bc/gen-products-breakdown', 'POST', undefined, undefined, body, );
    return res;
  }
  genClientReport = async (body: IGenClientReportRequestBody) => {
    const res = await Request.call('/api/bc/gen-client-report', 'POST', undefined, undefined, body, );
    return res;
  }
  genClientReportStatus = async (query: IGenClientReportStatusRequestQuery) => {
    const res = await Request.call('/api/bc/gen-client-report-status', 'GET', undefined, query, undefined, );
    return res;
  }
  invoiceLedgers = async (body: IInvoiceLedgersRequestBody) => {
    const res = await Request.call('/api/bc/invoice-ledgers', 'POST', undefined, undefined, body, );
    return res;
  }
  locationInfo = async (body: ILocationInfoRequestBody) => {
    const res = await Request.call('/api/bc/location-info', 'POST', undefined, undefined, body, );
    return res;
  }
  lastSyncTime = async (body: ILastSyncTimeRequestBody) => {
    const res = await Request.call('/api/bc/last-sync-time', 'POST', undefined, undefined, body, );
    return res;
  }
  genProductCategoriesBreakdown = async (body: IGenProductCategoriesBreakdownRequestBody) => {
    const res = await Request.call('/api/bc/gen-product-categories-breakdown', 'POST', undefined, undefined, body, );
    return res;
  }
  genDeliveryEmissions = async (body: IGenDeliveryEmissionsRequestBody) => {
    const res = await Request.call('/api/bc/gen-delivery-emissions', 'POST', undefined, undefined, body, );
    return res;
  }
  genCarbonFootprint = async (body: IGenCarbonFootprintRequestBody) => {
    const res = await Request.call('/api/bc/gen-carbon-footprint', 'POST', undefined, undefined, body, );
    return res;
  }
  invoiceDetail = async (params: IInvoiceDetailRequestParams) => {
    const res = await Request.call('/api/bc/invoice-detail/:no', 'GET', params, undefined, undefined, );
    return res;
  }
  invoiceDetailPost = async (body: IInvoiceDetailPostRequestBody) => {
    const res = await Request.call('/api/bc/invoice-detail-post', 'POST', undefined, undefined, body, );
    return res;
  }
  getStatsLedgerInvoices = async (body: IGetStatsLedgerInvoicesRequestBody) => {
    const res = await Request.call('/api/bc/get-stats-ledger-invoices', 'POST', undefined, undefined, body, );
    return res;
  }
  orderUpdateWebhook = async () => {
    const res = await Request.call('/api/bc/order-update-webhook', 'POST', undefined, undefined, undefined, );
    return res;
  }
  eventsWebhook = async () => {
    const res = await Request.call('/api/bc/events', 'POST', undefined, undefined, undefined, );
    return res;
  }
  listBCOrder = async (query: IListBCOrderRequestQuery) => {
    const res = await Request.call('/api/shopify/list-bc-order', 'GET', undefined, query, undefined, );
    return res;
  }
  appInvoiceLedgers = async (body: IAppInvoiceLedgersRequestBody) => {
    const res = await Request.call('/api/bc/app/invoice-ledgers', 'POST', undefined, undefined, body, );
    return res;
  }
  appLocationInfo = async (body: IAppLocationInfoRequestBody) => {
    const res = await Request.call('/api/bc/app/location-info', 'POST', undefined, undefined, body, );
    return res;
  }
  appInvoiceDetailPost = async (body: IAppInvoiceDetailPostRequestBody) => {
    const res = await Request.call('/api/bc/app/invoice-detail-post', 'POST', undefined, undefined, body, );
    return res;
  }
  getCustomerBudget = async () => {
    const res = await Request.call('/api/bc/get-customer-budget', 'GET', undefined, undefined, undefined, );
    return res;
  }
  getApprovedBuyerItems = async () => {
    const res = await Request.call('/api/bc/get-approved-buyer-items', 'GET', undefined, undefined, undefined, );
    return res;
  }
  listDespatchNotes = async (query: IListDespatchNotesRequestQuery) => {
    const res = await Request.call('/api/bc/despatch-notes', 'GET', undefined, query, undefined, );
    return res;
  }
  getDespatchNote = async (params: IGetDespatchNoteRequestParams) => {
    const res = await Request.call('/api/bc/despatch-notes/:despatchNoteNo', 'GET', params, undefined, undefined, );
    return res;
  }
  generateDespatchNoteLabels = async (params: IGenerateDespatchNoteLabelsRequestParams, body: IGenerateDespatchNoteLabelsRequestBody) => {
    const res = await Request.call('/api/bc/despatch-notes/:despatchNoteNo/generate-labels', 'POST', params, undefined, body, );
    return res;
  }
}
export default new BcAPI()